/**
 * Centralized API configuration - Runtime dynamic detection.
 * 
 * This config detects the correct backend URL at RUNTIME (not build time).
 * Works for ALL deployment scenarios:
 * - Preview: emergent.host domains
 * - Production: custom domains (geniusidiot.in, etc.)
 * - Local: localhost
 */

function getBackendUrl() {
  // Always use the current origin - this ensures the frontend
  // talks to the backend on the SAME domain it's deployed on
  const origin = window.location.origin;
  
  // Remove trailing slash if any
  return origin.replace(/\/$/, '');
}

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

// Debug logging (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('[API Config] Backend URL:', BACKEND_URL);
  console.log('[API Config] API URL:', API_URL);
}
